import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import ReviewsPage from "@/pages/reviews/ReviewsPage/ReviewsPage";
import useScroll from "../../common/hooks/useScroll";
import useApi from "@hooks/useApi";
import { api__getFeedbackList } from "@/apis/reviews/reviews";
import { useState } from "react";
var Reviews = function Reviews() {
  var _useState = useState(100),
    totalCount = _useState[0],
    setTotalCount = _useState[1];
  var _useScroll = useScroll(false, totalCount),
    page = _useScroll.page,
    ref = _useScroll.ref;
  var _useApi = useApi([page], function () {
      return api__getFeedbackList(page);
    }, function (originalData, newData) {
      setTotalCount(newData.pagination.total_pages);
      return {
        feedback_list: [].concat(_toConsumableArray((originalData === null || originalData === void 0 ? void 0 : originalData.feedback_list) || []), _toConsumableArray(newData.feedback_list)),
        pagination: newData.pagination
      };
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    data = _useApi2[2];
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    disableLoader: true,
    authenticationMsg: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true
  }, /*#__PURE__*/React.createElement(ReviewsPage, {
    feedbackList: (data === null || data === void 0 ? void 0 : data.feedback_list) || [],
    loading: loading,
    scrollLoadingAreaRef: ref
  }));
};
export default Reviews;